import * as React from 'react';
import { SelectSingle } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { FilterCommonProps } from './types';
import { ComplexValue } from 'ui';
import { OptionsType } from 'ui/common/select/types';

export class FilterCodeSingle extends React.PureComponent<FilterCommonProps<number>, { loadedOptions: LoadOptions }> {
  public state: Readonly<{ loadedOptions: LoadOptions }> = {
    loadedOptions: {}
  };

  private cleanValues = () => this.props.defaultValue?.cleanValues?.forEach(key => {
    this.props.updateFilterValues(key, undefined);
  });

  private onChange = (values: any) => {
    this.props.onChange(this.props.id, [values]);
    this.cleanValues();
  }

  private onLoadOptions = (options: LoadOptions) => {
    const { id, onLoadOptions, optionsEndpoint, optionsParams } = this.props;
    onLoadOptions(
      id,
      optionsEndpoint,
      options,
      optionsParams
    );
    this.setState({ loadedOptions: options });
    return;
  }
  public render() {
    const { id, label, values, options, fetchingOptions, optionsParams, translation } = this.props;
    return <SelectSingle
      className={''}
      componentId={id}
      label={label ? { text: label } : undefined}
      placeholder={translation?.search}
      fetching={fetchingOptions}
      valueItem={values?.[0]}
      options={options as ComplexValue<number>[]}
      onChange={this.onChange}
      loadOptions={this.state.loadedOptions}
      onLoadOptions={this.onLoadOptions}
      optionsDisplaySetting={{ type: OptionsType.flat }}
      onLoadOptionsDelay={0}
      minLength={optionsParams?.minLength}
    />;
  }
}
